export default __webpack_public_path__ + "static/media/logo192x192.9ecf3dc1.png";